import Link from 'next/link'

interface ButtonProps {
  title: string | JSX.Element
  href?: string
  className?: string
  onClick?: () => void
  bgGreen?: boolean
  shadow?: boolean
  border?: boolean
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
}

const Button: React.FC<ButtonProps> = ({
  title,
  href,
  className = '',
  onClick,
  bgGreen = true,
  shadow = true,
  border = false,
  type = 'button',
  disabled = false
}) => {
  const baseClasses = `${border ? 'border' : ''} ${shadow ? 'shadow-md' : ''} ${
    bgGreen ? 'bg-primary text-white' : 'bg-white text-black'
  } whitespace-nowrap rounded-full px-4 py-2 text-xs font-semibold transition-all duration-300 hover:scale-105 focus:outline-none sm:px-5 sm:py-2.5 sm:text-sm md:px-8 md:py-3 md:text-base ${className}`

  const button = (
    <button className={baseClasses} onClick={onClick} type={type} disabled={disabled}>
      {title}
    </button>
  )

  if (href) {
    return <Link href={href}>{button}</Link>
  }

  return button
}

export default Button
